/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseEmailTemplate } from './DatabaseEmailTemplate';
import {
    DatabaseEmailTemplateFromJSON,
    DatabaseEmailTemplateFromJSONTyped,
    DatabaseEmailTemplateToJSON,
} from './DatabaseEmailTemplate';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseLinkField } from './DatabaseLinkField';
import {
    DatabaseLinkFieldFromJSON,
    DatabaseLinkFieldFromJSONTyped,
    DatabaseLinkFieldToJSON,
} from './DatabaseLinkField';

/**
 * 
 * @export
 * @interface DatabaseEmailField
 */
export interface DatabaseEmailField extends DatabaseLinkField {
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseEmailField
     */
    hasMailtoLink?: boolean;
    /**
     * Adresse bestaetigen lassen (Double-Opt-In): Traegt ein Eintrag
     * eine neue oder geaenderte Adresse, geht eine Mail mit einem
     * einmaligen Bestaetigungslink an genau diese Adresse. Ein
     * Eintrag gilt als unbestaetigt, sobald die aktuelle Adresse von
     * der bestaetigten abweicht — deshalb genuegt EIN Schalter fuer
     * „neu" und „geaendert".
     * @type {boolean}
     * @memberof DatabaseEmailField
     */
    verifyEnabled?: boolean;
    /**
     * 
     * @type {DatabaseEmailTemplate}
     * @memberof DatabaseEmailField
     */
    verifyTemplate?: DatabaseEmailTemplate;
    /**
     * Optionales Ziel-Datumsfeld, in das der Bestaetigungszeitpunkt
     * geschrieben wird — damit er in Liste, Filter und Export
     * auftaucht. Dieses Feld darf niemals fuer oeffentliche Formulare
     * freigegeben werden (sonst stellt sich jeder die Bestaetigung
     * selbst aus); der Verifizierungs-Dienst sperrt es zusaetzlich.
     * @type {string}
     * @memberof DatabaseEmailField
     */
    verifiedAtFieldId?: string;
}

/**
 * Check if a given object implements the DatabaseEmailField interface.
 */
export function instanceOfDatabaseEmailField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseEmailFieldFromJSON(json: any): DatabaseEmailField {
    return DatabaseEmailFieldFromJSONTyped(json, false);
}

export function DatabaseEmailFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseEmailField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseLinkFieldFromJSONTyped(json, ignoreDiscriminator),
        'hasMailtoLink': !exists(json, 'hasMailtoLink') ? undefined : json['hasMailtoLink'],
        'verifyEnabled': !exists(json, 'verifyEnabled') ? undefined : json['verifyEnabled'],
        'verifyTemplate': !exists(json, 'verifyTemplate') ? undefined : DatabaseEmailTemplateFromJSON(json['verifyTemplate']),
        'verifiedAtFieldId': !exists(json, 'verifiedAtFieldId') ? undefined : json['verifiedAtFieldId'],
    };
}

export function DatabaseEmailFieldToJSON(value?: DatabaseEmailField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseLinkFieldToJSON(value),
        'hasMailtoLink': value.hasMailtoLink,
        'verifyEnabled': value.verifyEnabled,
        'verifyTemplate': DatabaseEmailTemplateToJSON(value.verifyTemplate),
        'verifiedAtFieldId': value.verifiedAtFieldId,
    };
}

